import React from 'react'
import isEmpty from 'lodash/isEmpty'
import map from 'lodash/map'
import type {
  GlobalSearchResultGroup as GlobalSearchResultGroupType,
  GlobalSearchResult,
} from '@ztechapps/common.contract'
import { GlobalSearchResultItem } from './GlobalSearchResultItem'
import { ListGroup } from 'react-bootstrap'

export type GlobalSearchResultGroupProps = {
  group: GlobalSearchResultGroupType
  /** The heading printed for the group; the raw module name when omitted. */
  label?: string
  onResultClick: (result: GlobalSearchResult) => void
}

export const GlobalSearchResultGroup = ({
  group,
  label = group.module,
  onResultClick,
}: GlobalSearchResultGroupProps) => {
  if (isEmpty(group.results)) {
    return null
  }

  return (
    <div className="mb-2">
      {/* bg-body-secondary tracks the active theme; bg-light is a fixed light colour that stayed
          near-white in dark mode, leaving this header's muted text almost unreadable. */}
      <div className="px-2 py-1 bg-body-secondary border-bottom">
        <small className="text-muted fw-bold">
          {label} ({group.count} {group.count === 1 ? 'result' : 'results'})
        </small>
      </div>
      <ListGroup>
        {map(group.results, (result, index) => {
          const isLast = index === group.results.length - 1
          return <GlobalSearchResultItem key={result._id} result={result} onClick={onResultClick} isLast={isLast} />
        })}
      </ListGroup>
    </div>
  )
}
